module.exports = __webpack_public_path__ + "img/light_img2.ef43ad25.png";